/** Tarjeta compartida para listas de documentos (requerimientos y presupuestos). */
import { MobileIcon, type MobileIconName } from './MobileIcon';
import { StatusBadge } from './StatusBadge';

type EntityListCardProps = {
  eyebrow: string;
  title?: string;
  status: string;
  tag?: string;
  metadata: Array<{ icon?: MobileIconName; text: string; title?: string }>;
  onClick: () => void;
  ariaLabel?: string;
};

export function EntityListCard({
  eyebrow,
  title,
  status,
  tag,
  metadata,
  onClick,
  ariaLabel,
}: EntityListCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="w-full rounded-card bg-white p-4 text-left shadow-card transition-all active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    >
      <span className="flex items-start justify-between gap-3">
        <span title={eyebrow} className="min-w-0 flex-1 truncate text-sm font-semibold text-text-primary">
          {eyebrow}
        </span>
        <StatusBadge status={status} size="sm" />
      </span>

      {title && (
        <span className="mt-1 line-clamp-2 break-words text-base font-semibold text-text-primary">
          {title}
        </span>
      )}

      {metadata.length > 0 && (
        <span className="mt-3 block space-y-1.5 text-sm text-text-secondary">
          {metadata.map((item, index) => (
            <span key={`${item.text}-${index}`} className="flex min-w-0 items-center gap-1.5">
              {item.icon && (
                <MobileIcon name={item.icon} className="h-4 w-4 shrink-0 text-text-tertiary" />
              )}
              <span title={item.title ?? item.text} className="min-w-0 flex-1 truncate">
                {item.text}
              </span>
            </span>
          ))}
        </span>
      )}

      {tag && (
        <span className="mt-3 inline-flex rounded-full bg-primary-light px-2.5 py-0.5 text-xs font-semibold text-primary">
          {tag}
        </span>
      )}
    </button>
  );
}
